import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

const ReadContract = () => {

    const navigate = useNavigate();
    const [leaseAgreementBody, setLeaseAgreementBody] = useState('');
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({
        negotiation: {},
        images: []
    });

    const location = useLocation();
    const id = decodeURIComponent(location.pathname.split('/readcontract/')[1]);

    useEffect(() => {
        async function getContract() {
            try {
                setLoading(true);
                // console.log('negotiationID', id);

                const response = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                    action: 'GetContractByContractId',
                    id: id,
                });
                if (response.data.status === true) {

                    setItem(response.data.data);
                    setLoading(false);
                } else {
                    Swal.fire({
                        icon: 'info',
                        title: response.data.message,
                    });
                    navigate('/')
                }
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        }

        getContract();
    }, [id]);


    const formatDate = (dateString) => {
        const dateParts = dateString.split("-");
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];
        return `${month}/${day}/${year}`;
    };

    useEffect(() => {

        const {
            ownerName,
            renterName,
            placeAddress,
            placeDescription,
            activeMilitary,
            storageType,
            rentalRate,
            deposit,
            lateCharge,
            bounceFee,
            lateLetterCharge,
            lienLetterCharge,
            inventory,
            advertising,
            placeState,
            placeCounty,
            ownerAddress,
            ownerPhone,
            ownerEmail,
            renterAddress,
            renterPhone,
            renterEmail,
            alternateName,
            alternateAddress,
            alternatePhone,
            alternateEmail,
            commChoice

        } = item;

        const formattedLeaseAgreeDate = item.leaseAgreeDate ? formatDate(item.leaseAgreeDate) : '';
        const formattedLeaseStartDate = item.leaseStartDate ? formatDate(item.leaseStartDate) : '';
        const formattedRentPaymentDay = item.rentPaymentDay ? formatDate(item.rentPaymentDay) : '';

        const commValue = {
            "1": "** OCCUPANT WISHES TO RECEIVE E-MAIL COMMUNICATIONS AND TEXT MESSAGES WITH REGARDS TO THIS AGREEMENT. By choosing the option to receive e-mail/text communication in this agreement, Owner will provide Occupant notices and other information regarding your account through e-mail/text to the mobile phone numbers and email addresses provided by Occupant in the tenant profile, or in a subsequent written change of mobile phone numbers or email addresses, and such change has been provided to Owner",
            "2": "** Occupant elects to receive all communication by First Class U.S. Postal Service",
            "default": "communication choice NOT selected"
        }[commChoice];

        const leaseAgreementBody = `
            <h2>LEASE AGREEMENT</h2>
            <p>
                This lease agreement for storage space is entered into on ${formattedLeaseAgreeDate} between ${ownerName} (herein called Owner) and ${renterName} (herein called Occupant) for rental of the space commonly known as ${placeAddress}, and further described as ${placeDescription}.
                
                Are you or your spouse on active-duty military service? ${activeMilitary}.
            </p>
            <ul>
                <li>
                    Lease Occupancy Start Date ${formattedLeaseStartDate}
                    Space Description: ${storageType}
                    Rent Due Date: ${formattedRentPaymentDay}
                    Rent: $${rentalRate}
                    Sec. Dep.: $${deposit}
                    Late Fee: $${lateCharge}
                    Bad Check Charge: $${bounceFee}
                    Late Letter Charge: $${lateLetterCharge}
                    Lien Letter Charge: $${lienLetterCharge}
                    Inventory: $${inventory}
                    Advertising: $${advertising}
                </li>
            </ul>
            <p>
    <h3>IMPORTANT NOTICES:</h3>
    <h4>NOTICE OF LIEN</h4>
<p>
    Pursuant to the ${placeState} Self-Service Storage Facility law your property will be subject to a claim of lien for unpaid rent and other charges and may even be sold to satisfy the lien if rent and other charges due remain unpaid for fourteen (14) consecutive days.
</p>
<h4>LIEN NOTIFICATION by ELECTRONIC MAIL</h4>
<p>
    Lien notices may be sent to the Occupant and to the alternate person designated, by electronic mail.
</p>
<h4>OWNER’S RIGHT TO TOW:</h4>
<p>
 Pursuant to the ${placeState} Self-Service Storage Facility law, Owner also has the right to tow a vehicle, watercraft or trailer from the facility when rent and other charges are 60 or more days past due.
</p>
<h4>SPACE SIZE APPROXIMATE</h4>
<p>
    Space sizes are approximate and for comparison purposes only. Spaces may be smaller or larger than indicated in advertising or other size indicators.
</p>
<h3>TERMS AND CONDITIONS OF LEASE</h3>

<p>
Owner rents to Occupant the storage space indicated above pursuant to the following terms and conditions:
</p>
<h4>TERM</h4>
<p>
    The term of the tenancy shall commence on the date indicated above ${formattedRentPaymentDay} and shall continue until terminated on a month-to-month basis. The minimum rental term is one month.
</p>
<h4>RENT</h4>
<p>
    The rent shall be the amount stated above $${rentalRate} and paid to Owner at the address stated above. Rent is due each month on the rent due date in advance and without demand. Owner reserves the right to require that rent and other charges be paid in cash, certified check or money order. Owner may change the monthly rent or other charges by giving Occupant fifteen (15) days advanced written notice by first-class mail or by email at the postal address or email address stated in this agreement. The new rent shall become effective on the next date rent is due. If Occupant has made advanced rental payments, the new rent will be charged against such payments, effective upon giving notice of the new rate.
</p>
<h4>PARTIAL RENT PAYMENTS</h4>
<p>
    Owner, at Owner’s sole discretion, may accept or reject partial rent payments. Acceptance of partial rent payments by Owner shall not constitute a waiver of Owner’s rights. Occupant understands and agrees that acceptance of a partial rent payment shall not delay or stop foreclosure on Occupant’s stored property as provided by the ${placeState} State Self-service Storage Facility laws.
</p>
<h4>ELECTRONIC BANKING PAYMENTS</h4>
<p>
    Tenant shall pay all Rent via STRIPE; provided, however, Tenant reserves the right, subject to ${placeState} State Civil Code, to pay Rent by check.
</p>
<h4>CHANGE OF ADDRESS</h4>
<p>
    Occupant must provide address changes to Owner in writing. Occupant must also provide address change of Alternate Person to Owner in writing. Such changes will become effective when received by Owner. It is the responsibility of the Occupant to verify that Owner has received and recorded the requested change of address.    
</p>
<h4>SECURITY DEPOSIT</h4>
<p>
    Occupant will pay in advance a security deposit in the amount stated above $${deposit} to secure Occupant’s faithful performance of all terms of this rental agreement. Occupant agrees that Owner need not segregate this deposit from other funds and that no interest will be due for the period during which the deposit is held. This deposit, less all expenses incurred by Owner for damage to or cleaning of the storage space, shall be returned to Occupant within 15 days after Occupant removes all stored property from the storage space. At Owner’s sole option, amounts may be withheld from the security deposit to compensate Owner for rent or any other charges due and unpaid under this agreement at the time Occupant relinquishes, abandons, or otherwise loses possession of the storage space. Owner reserves the right to require an additional security deposit when deemed necessary in Owner’s sole discretion.
</p>
<h4>LATE FEES AND OTHER CHARGES</h4>
<p>
    Occupant agrees to pay Owner the indicated late fee stated above 15% of monthly rent if rent is received ten (10) or more days after the due date. Occupant will pay Owner the indicated fee for each letter sent to Occupant, notifying Occupant of the default. Occupant agrees to pay Owner the stated “Bad Check Charge” in amount stated above ${bounceFee} plus all bank charges for any dishonored check. These fees are considered additional rent and are to compensate Owner for labor and other costs of collection. In the event of default, Occupant agrees to pay all collection and lien costs incurred by owner, including lien letter, advertising and inventory charges.
</p>
<h4>CROSS COLLATERALIZATION OF SPACES</h4>
<p>
    When Occupant rents more than one space at from Owner, the rent is secured by the property in all the spaces rented. Failure by Occupant to pay on any space shall be considered a default on all spaces rented. Owner may exercise all available remedies, including but not limited to denial of access to the spaces and sale of the property, if Occupant does not pay all rent due on all spaces rented.
PROPERTY ACCESS REVOKED: When rent or other charges remain unpaid for ten (10) consecutive days, Owner may revoke Occupant’s access to the property, including any electronic gate access. If access is revoked, Occupant will only have access to the space by prearrangement with Owner prior to entering property.
</p>
<h4>TERMINATION</h4>
<p>
    Thirty (30) days advanced written notice given by Owner or Occupant to the other party will terminate this tenancy. Owner does not prorate rent; only full months’ prepaid rent shall be returned to Occupant within fifteen (15) days of vacating the unit. Occupant must leave the space broom clean and in good condition. Occupant is responsible for all damages.
</p>
<h4>USE OF STORAGE SPACE</h4>
<p>
    Occupant agrees to use the storage space only for the storage of property wholly owned by Occupant. Occupant shall not store food or any perishable items in the space. Occupant agrees not to store collectibles, heirlooms, jewelry, works of art or any property having special or sentimental value to Occupant. Occupant waives any claim for emotional or sentimental attachment to the stored property. There shall be no residential occupancy of the space. Violation of these prohibitions shall be grounds for immediate termination of your tenancy.
</p>
<h4>HAZARDOUS OR TOXIC MATERIALS PROHIBITED</h4>
<p>
  Occupant is strictly prohibited from storing or using materials in the storage space or on the facility classified as hazardous or toxic under any local, state or federal law or regulation, and from engaging in any activity, which produces such materials. Occupant’s obligation of indemnity as set forth below specifically includes any costs, expenses, fines, or penalties imposed against the Owner, arising out of the storage or use of any hazardous or toxic material by Occupant, Occupant’s agents, employees, invitees, or guests. Owner may enter the storage space at any time to remove and dispose of prohibited items.
</p>
<h4>INSURANCE</h4>
   <p> Occupant, at Occupant’s expense, shall maintain a policy of fire, extended coverage endorsement, burglary, vandalism, and malicious mischief insurance for the actual cash value of stored property. Insurance on Occupant’s property is a material condition of this agreement and is for the benefit of both Occupant and Owner. Failure to carry the required insurance is a breach of this agreement and Occupant assumes all risk of loss to stored property that would be covered by such insurance. Occupant expressly agrees that the insurance company providing such insurance shall not be subrogated to any claim of Occupant against Owner, Owner’s agents, or employees for loss of or damage to stored property.
</p>
<h4>RELEASE OF OWNER’S LIABILITY FOR PROPERTY DAMAGE</h4>
<p>
    All personal property stored within or upon the storage space by Occupant shall be at Occupant’s sole risk. Owner and Owner’s agents and employees shall not be liable for any loss of or damage to any personal property in the storage space or at the storage facility arising from any cause whatsoever including, but not limited to, burglary, mysterious disappearance, fire, water damage, rodents, Acts of God, the active or passive acts or omissions or negligence of the Owner, Owner’s agents, or employees.
</p>
<h4>RELEASE OF OWNER’S LIABILITY FOR BODILY INJURY</h4>
<p>
    Owner, Owner’s agents and employees shall not be liable to Occupant for injury or death as a result of Occupant’s use of the storage space or the storage facility, even if such injury is caused by the active or passive acts or omissions or negligence of the Owner, Owner’s agents or employees.
</p>
<h4>INDEMNITY</h4>
<p>
    Occupant agrees to indemnify, hold harmless and defend Owner from all claims, demands, actions, or causes of action (including attorneys’ fees and all costs) that are hereinafter brought by others arising out of Occupant’s use of the storage space and common areas, including claims for Owner’s active negligence.
</p>
<h4>TIME TO MAKE CLAIM OR BRING SUIT</h4>
<p>
    Occupant must bring any claim that arises out of this rental agreement for loss of or damage to stored property within twelve (12) months of the date of the acts, omissions that gave rise to such claim or suit or twelve (12) months after the termination of this rental agreement, whichever occurs first.
</p>
<h4>RULES AND REGULATIONS</h4>
<p>
    Owner shall have the right to establish or change the hours of operation for the facility and to promulgate rules and regulations for the safety, care and cleanliness of the storage space or the preservation of good order on the facility. Occupant agrees to follow all rules and regulations now in effect, or that may be put into effect from time to time.
</p>
<h4>PROPERTY LEFT IN THE STORAGE SPACE</h4>
<p>
    Owner may dispose of any property left or abandoned in the storage space or on the storage facility by Occupant after Occupant has terminated his or her tenancy. Occupant shall be responsible for paying all costs incurred by Owner in disposing of such property.
</p>
<h4>CLIMATE CONTROLLED SPACES</h4>
<p>
    Climate controlled space is heated or cooled. These spaces do not provide constant internal temperature or humidity control. Owner does not warrant or guarantee temperature or humidity ranges inside the space due to changes in outside temperature or humidity.
</p>
<h4>OCCUPANT ACCESS</h4>
<p>
    Occupant’s access to the storage facility may be conditioned in any manner deemed reasonably necessary by Owner to maintain order. Such measures may include but are not limited to, limiting hours of operation, requiring verification of Occupant’s identity, and inspecting vehicles that enter the storage facility.
</p>
<h4>OWNER’S RIGHT TO ENTER</h4>
<p>
    Occupant grants Owner, Owner’s agents, or representatives of any governmental authority, including police and fire officials, access to the storage space upon three (3) days advanced written notice to Occupant. In the event of an emergency, Owner, Owner’s agents or representatives of governmental authority shall have the right to enter the storage space without notice to Occupant, and take such action as may be necessary or appropriate to protect the storage facility, to comply with applicable law or enforce owner’s rights. Once per year the fire sprinklers located inside each unit need to be inspected, per state law. Owner will notify Occupant a minimum of three (3) days in advance of inspection. At no time will inspectors be inside an occupied until without Owner/Management physically present.
</p>
<h4>NOTICES</h4>
<p>
    All notices required by this rental agreement shall be sent by first class mail postage prepaid to Occupant’s last known mailing address or by email to the email address provided by the Occupant in this rental agreement or written change thereto. Notices shall be deemed given when deposited in the United States mail or sent to the electronic mail address provided by Occupant. Occupant agrees that mailed notice is conclusively presumed to have been received by Occupant five (5) days after mailing unless returned to Owner by the U.S. Postal Service and that electronic mail notices shall be deemed delivered upon sending unless Owner receives notice of non-delivery within 48 hours of sending the notice. All statutory notices shall be sent as required by law.
</p>
   <p> Notice for Service:
</p>
            <ul>
                <li>
                    <strong>Owner</strong>
                    ${ownerName}
                    ${ownerAddress}
                    ${ownerPhone}
                    ${ownerEmail}
                </li>
                <li>
                    <strong>Occupant</strong>
                    ${renterName}
                    ${renterAddress}
                    ${renterPhone}
                    ${renterEmail}
                </li>
                <li>
                    <strong>Alternate Person</strong>
                    ${alternateName}
                    ${alternateAddress}
                    ${alternatePhone}
                    ${alternateEmail}
                </li>
            </ul>
            <p>
                ${commValue}
            </p>         
<p>
<h4>NO SUBLETTING</h4>
    Occupant shall not assign or sublease the storage space without the written consent of the Owner. Owner may withhold consent to sublet or assign for any reason or for no reason in Owner’s sole discretion.
</p>
<p>
<h4>MILITARY SERVICE</h4>
    If Occupant or Occupant’s spouse is in the military service Occupant must provide written notice of such to the Owner in this rental agreement or at the address of the property. The Owner will rely on this information to determine the Occupant’s rights pursuant to the Service members Civil Relief Act.
<br>
Occupant designates Active Military Service ${activeMilitary}
</p>
<p>
<h4>COMMUNICATION</h4>
    Occupant understands that Owner and Occupant are entering into a business relationship. Occupant agrees to keep at least one valid and working phone number on file with Owner at all times for the purposes of contact by Owner.  Occupant authorizes and consents to Owner contacting Occupant at Occupant’s residence, cell phone and email address by automated telephone calls, texts or emails. Such automated calls or messages may be used for conveying important facility information, marketing, or collection purposes.  Occupant further authorizes and consents to Owner contacting Alternate Person at Alternates residence, cell phone and email address.
</p>
<p>
<h4>NO WARRANTIES</h4>
    No expressed or implied warranties are given by Owner, Owner’s agents or employees as to the suitability of the storage space for Occupant’s intended use. Owner disclaims and Occupant waives any implied warranties of suitability or fitness for a particular use.
</p>
<p>
<h4>NO ORAL AGREEMENTS</h4>
    This rental agreement contains the entire agreement between Owner and Occupant, and no oral agreements shall be of any effect whatsoever. Occupant acknowledges that no representations or warranties have been made with respect to the safety, security or suitability of the storage space for the storage of Occupant’s property and that Occupant has made his or her determination of such matters solely from inspection of the storage space and the facility. Occupant understands and agrees that this agreement may be modified only in writing, signed by both parties.
</p>
<p>
<h4>SUCCESSION</h4>
    All provisions of this rental agreement shall apply to and be binding upon all successors in interest, assigns or representatives of the parties hereto.
</p>
<p>
<h4>SEVERABILITY</h4>
    If any part of this rental agreement is held to be unenforceable for any reason, in any circumstance, the parties agree that such part shall be enforceable in other circumstances, and that all the remaining parts of this agreement will be valid and enforceable.
</p>
<p>
<h4>JURISDICTION</h4>                                           
   Owner and Tenant agree that the exclusive venue for any dispute arising from this agreement will be heard by the Superior Court of ${placeCounty} County, state of  ${placeState} .   This agreement shall be interpreted and enforced according to the laws of said state and county.  Landlord and Tenant waive any and all rights to object to venue, including any claim of inconvenience. 
</p>
<p>
<h4>NO ALTERATIONS</h4>     
    Occupant shall make no alterations to the interior or exterior of the space without the written permission of the Owner authorizing such alterations.
</p>
<br>
<p>
<h4>UNDERSTANDING</h4>
    Do not sign this agreement until you have read it, including the provision on the other side, and fully understand it. This agreement limits the Owner’s liability for loss of or damage to your stored property. If you have any questions concerning its legal effect, consult your legal advisor.
</p>
<h4>Signatures</h4>
            <h3>Owner</h3>____________________________________<h3>Renter</h3>_______________________________________
        `;

        setLeaseAgreementBody(leaseAgreementBody);


    }, [item])


    const printLeaseAgreement = () => {
    

        // Get current date
        const currentDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

        // Open a new window for printing
        const printWindow = window.open("", "_blank");

        // Write the content to the print window
        printWindow.document.write("<!DOCTYPE html>");
        printWindow.document.write("<html lang='en'>");
        printWindow.document.write("<head><meta charset='UTF-8'><title>Lease Agreement</title>");
        printWindow.document.write("<style>@media print { body { font-size: 12pt; } #printWindowContent { width: 8.5in; height: auto; margin: 10px auto; padding: 20px; box-sizing: border-box; } .footer { position: absolute; bottom: 20px; left: 0; width: 100%; text-align: center; }</style>");
        printWindow.document.write("</head>");
        printWindow.document.write("<body>");
        printWindow.document.write(`<div id='printWindowContent'>${leaseAgreementBody}</div>`);
        // Optionally, you can include a footer with page number and date
        // printWindow.document.write(`<div className="footer">Page 1 of 1 - Printed on: ${currentDate}</div>`);
        printWindow.document.write("</body>");
        printWindow.document.write("</html>");
        printWindow.document.close();

        // Focus and print the content
        printWindow.focus();
        printWindow.print();
    };
    if (loading) {
        return <p>Loading...</p>;
    }


    return (
        <section className="page-content sec-padding">

            <div className="container">
                <div className="page-content-details">

                    <div className="sec-title row">
                        <div className="col-md-6 text-start">
                            <h3>Contract</h3>
                        </div>
                        <div className="col-md-6 text-end">
                            <Link className='btn btn-primary btn-lg add_garage me-2' to='/view-contract'>Manage Contracts</Link>
                            <button type="submit" className='btn btn-lg btn-primary' onClick={printLeaseAgreement}>Print Contract</button>


                        </div>
                    </div>

                    <div className='card leaseform'>
                        <div className='fontfamilyarial card-body' dangerouslySetInnerHTML={{ __html: leaseAgreementBody }}></div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ReadContract;

